import { Invite } from '../data/invite.do';
import { OrganizationMembership } from '../data/organization-membership.do';


/**
 * Holds Mobiz Info related to an ERP user information.
 * @membership Present only if ERP user has a DK account
 * @invite Present only if ERP user is invited
 */
export interface MobizMembership {
  membership?: OrganizationMembership;
  invite?: Invite;
}
